module.exports = __webpack_public_path__ + "media/images/banners/Shrimp Balls-f732f38e45161aa4e24740a3deba1767.JPG";